import * as Yup from 'yup';
import { TYPES } from './ShipmentReferenceForm';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    label: Yup.string()
      .required(t('Reference Label is required'))
      .nullable(),
    customFieldTypeId: Yup.string()
      .required(t('Field Type is required'))
      .nullable(),
    listItems: Yup.array().when('customFieldTypeId', {
      is: val => val === TYPES.DROP_DOWN || val === TYPES.COMBO,
      then: Yup.array()
        .required(t('Values is required'))
        .min(2, 'Define at least 2 values')
    })
  });

export default validationSchema;
